import CartList from "./List";

const router = [{ path: "/cart", component: CartList, exact: true }];

export default router;
